module.exports = __webpack_public_path__ + "img/houdini_spirits.e254918.webp";